// The roof area a trace implies: every traced polygon is a flat footprint, so the total is
// footprint x pitch factor (same correction TracedMeasurements shows), rounded to a whole sqft.
// Length traces do not count. Null when no area has been traced.
import type { DrawnShape } from '@/components/QuickQuote/QuickQuoteMap';
import { pitchMultiplier } from '@/lib/roofPitch';

export function tracedRoofAreaSqft(shapes: DrawnShape[], activePitch: number | null): number | null {
  const polygons = shapes.filter((s) => s.type === 'polygon');
  if (polygons.length === 0) return null;
  const footprint = polygons.reduce((sum, s) => sum + (s.area_sqft ?? 0), 0);
  return Math.round(footprint * (activePitch != null ? pitchMultiplier(activePitch) : 1));
}
